import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { APPLY_URL } from "@/lib/constants";

export function Guarantee() {
  return (
    <section
      data-testid="guarantee-section"
      className="border-t border-black/10 bg-ink text-white"
    >
      <div className="mx-auto max-w-[1600px] px-5 py-32 md:px-10 md:py-40">
        <Reveal>
          <p className="font-mono2 text-xs uppercase tracking-[0.25em] text-white/70">
            Our commitment
          </p>
          <h2 className="mt-8 max-w-6xl font-display text-5xl font-black leading-[0.95] tracking-tighter sm:text-6xl lg:text-7xl">
            COMPLETE EVERY CHECKPOINT. MISS $10,000 IN GROSS SALES IN SIX MONTHS, AND WE WORK FREE UNTIL YOU HIT IT.
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <div
            data-testid="commitment-disclaimer"
            className="mt-10 max-w-3xl border border-white/25 p-6 md:p-8"
          >
            <p className="font-mono2 text-[10px] uppercase tracking-[0.2em] text-white/60">
              Commitment disclaimer
            </p>
            <p className="mt-3 font-body text-sm leading-relaxed text-white/80">
              This is a commitment to continue providing coaching. It is not a
              guarantee of income, profit, or results. Gross sales are total
              product revenue before fees, cost of goods, and expenses, and do
              not represent profit. Results depend on the capital you deploy,
              the time you invest, your execution, and market conditions.
            </p>
          </div>
        </Reveal>
        <Reveal delay={0.15} className="mt-12">
          <p
            data-testid="guarantee-qualification"
            className="max-w-xl border-l-2 border-white/40 pl-4 font-body text-xs leading-relaxed text-white/70"
          >
            Before you apply: this program requires at least{" "}
            <span className="font-semibold text-white">
              $5,000 in working capital
            </span>{" "}
            for inventory, separate from the program fee. Without deployable
            capital the program cannot be completed.
          </p>
          <a
            href={APPLY_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="guarantee-cta-button"
            className="group mt-6 inline-flex items-center gap-3 bg-white px-8 py-4 font-mono2 text-sm font-medium uppercase tracking-[0.15em] text-ink transition-colors duration-200 hover:bg-signal hover:text-white"
          >
            Apply for 1 of 10 Seats
            <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" />
          </a>
        </Reveal>
      </div>
    </section>
  );
}
